import { Component, OnInit } from '@angular/core';
import {Permissions} from '../../shared/models/permissions.model';
import {Router} from '@angular/router';
import {PermissionService} from '../../shared/services/permission.service';
import {RelationshipManager} from '../../shared/models/relationship-manager.model';
import {CompanyService} from '../../shared/services/company.service';

@Component({
  selector: 'app-nav-footer',
  templateUrl: './nav-footer.component.html',
})
export class NavFooterComponent implements OnInit {

  relationshipManagers: Array<RelationshipManager>;
  permissions: Permissions;
  canViewLoans = true;
  canViewReports = true;
  canViewMyProfile = true;
  canViewAdmin = true;
  canViewDocuments = true;
  canCRUDMasterAdmin = true;

  constructor(private companyService: CompanyService,
              private router: Router,
              private permissionsService: PermissionService) { }

  ngOnInit() {
    this.permissionsService.permissions$.subscribe((permissions: Permissions) => {
      if (permissions) {
        this.permissions = permissions;
        this.canViewLoans = this.permissions.canViewLoans;
        this.canViewReports = this.permissions.canViewReports;
        this.canViewMyProfile = this.permissions.canViewProfile;
        this.canViewAdmin = this.permissions.canViewAdmin;
        this.canViewDocuments = this.permissions.canViewDocuments;
        this.canCRUDMasterAdmin = this.permissions.canCRUDMasterAdmin;
        this.companyService.getRelationshipManagers().then(
          res => {
            this.relationshipManagers = res;
            console.log(res);
          }
        ).catch((error) => {
          console.error('Error Retrieving Relationship Manager Data');
          console.error(error);
        });
      }
    });
  }

  routeTo(route: string) {
    this.router.navigate([route]);
  }

}
